import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@/lib/utils'

/** An accessible form label built on Radix `Label` (associates via `htmlFor`). */
export const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(function Label({ className, ...props }, ref) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        // `block` so a label always sits on its own line above its control —
        // otherwise an inline label beside an inline-flex control (e.g. the
        // TimePicker trigger) reads as a left-aligned label. Field wrappers stack
        // label-over-control consistently regardless of the control's display.
        'block text-control font-medium text-ink peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  )
})
